export const HOME = {
  emergentLink: 'home-emergent-link',
  heroHeading: 'home-hero-heading',
  openAccountBtn: 'home-open-account-btn',
  loginBtn: 'home-login-btn',
};

export const AUTH = {
  loginForm: 'auth-login-form',
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  submitBtn: 'auth-submit-btn',
  registerLink: 'auth-register-link',
  registerForm: 'auth-register-form',
  fullNameInput: 'auth-fullname-input',
};

export const DASHBOARD = {
  container: 'dashboard-container',
  balanceCard: 'dashboard-balance-card',
  equityCard: 'dashboard-equity-card',
  marginCard: 'dashboard-margin-card',
  plCard: 'dashboard-pl-card',
};

export const WEBTRADER = {
  container: 'webtrader-container',
  watchlist: 'webtrader-watchlist',
  chartContainer: 'webtrader-chart-container',
  orderTicket: 'webtrader-order-ticket',
  buyBtn: 'webtrader-buy-btn',
  sellBtn: 'webtrader-sell-btn',
  volumeInput: 'webtrader-volume-input',
  positionsTab: 'webtrader-positions-tab',
  closePositionBtn: 'webtrader-close-position-btn',
};

export const ADMIN = {
  clientsList: 'admin-clients-list',
  transactionsList: 'admin-transactions-list',
  approveBtn: 'admin-approve-btn',
  rejectBtn: 'admin-reject-btn',
};